import { X } from 'lucide-react'
import { useT } from '../../hooks/useTranslation'

/**
 * SCALPEX — Одноразовое уведомление о смене рекомендуемого режима (task.txt №3).
 *
 * Когда админ меняет рекомендуемый режим (Шорт/Лонг) во вкладке «Админ», бэкенд
 * штампует adminConfig.modeChangedAt. App.jsx сравнивает его с меткой юзера
 * users.mode_notice_seen_at (приходит в /users/me → modeNoticeSeenAt) и, если
 * смена произошла ПОСЛЕ последней просмотренной метки, показывает это окно по
 * центру экрана. При закрытии метка записывается на бэкенд — до следующей смены
 * режима уведомление больше не появится. Админу не показывается (условие в App.jsx).
 */
export default function ModeChangeNotice({ mode = 'short', onDismiss }) {
  const t = useT()
  const isLong = mode === 'long'

  return (
    <div
      onClick={onDismiss}
      style={{
        position: 'fixed', inset: 0, zIndex: 12000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0,0,0,0.5)', padding: 24,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        style={{
          position: 'relative', width: '100%', maxWidth: 320,
          background: '#1B1B1F', border: '1px solid rgba(255,255,255,0.09)',
          borderRadius: 18, padding: '20px 20px 18px',
          boxShadow: '0 14px 44px rgba(0,0,0,0.55)',
        }}
      >
        <button
          onClick={onDismiss}
          aria-label={t.modeNoticeDismiss}
          style={{
            position: 'absolute', top: 10, right: 10,
            width: 30, height: 30, borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)', border: 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#9B9B9F', cursor: 'pointer',
          }}
        >
          <X size={16} />
        </button>

        <div
          style={{
            fontSize: 12, color: 'var(--accent)', fontWeight: 600,
            letterSpacing: 0.4, textTransform: 'uppercase', paddingRight: 26,
          }}
        >
          ⚙️ {t.modeNoticeTitle}
        </div>

        <div style={{ marginTop: 12, fontSize: 15, color: '#E0E0E3', lineHeight: 1.5 }}>
          {isLong ? t.modeNoticeTextLong : t.modeNoticeTextShort}
        </div>

        <button
          onClick={onDismiss}
          style={{
            marginTop: 18, width: '100%', padding: '12px 14px', borderRadius: 12,
            border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 15,
            color: '#0B120E',
            background: 'linear-gradient(135deg, var(--accent) 0%, var(--accent-strong) 100%)',
            boxShadow: '0 6px 18px rgba(16,185,129,0.25)',
          }}
        >
          {t.modeNoticeDismiss}
        </button>
      </div>
    </div>
  )
}
